import { boot } from 'quasar/wrappers';
import { storeToRefs } from 'pinia';
import { useRouting } from 'composables/routing';
import useWebsocket from 'composables/websocket';
import { useSearchStore } from '#src/store/search';

export default boot(({ router }) => {
  const searchStore = useSearchStore();
  const { accounts, devices } = storeToRefs(searchStore);
  const { toAccount, toDevice } = useRouting(router);
  const { ws } = useWebsocket();

  router.beforeEach(async (to, _, next) => {
    if (to.name === 'home') {
      await searchStore.search(<string>to.query.terms || '', true);

      if (devices.value.length === 1 && accounts.value.length === 0) {
        void toDevice(devices.value[0].accountKey, devices.value[0].serial);
      } else if (accounts.value.length === 1 && devices.value.length === 0) {
        void toAccount(accounts.value[0].key);
      }
    }
    next();
  });

  ws.on('search/newResult', (payload) => {
    const { progress, result, type } = <
      { progress: number; result: ApiAccount | ApiDevice; type: 'account' | 'device' }
    >payload;
    searchStore.setProgress(progress);
    searchStore.addResult(type, result);
  });
});
